areaMembros.component('areaMembros.comunidadeEditComponent', {
    templateUrl: 'areaMembros/areaMembrosDetalhe/comunidadeEdit/comunidadeEdit.html',
    controller: 'areaMembros.comunidadeController',
    controllerAs: '$ctrl',
    bindings: { areaMembros: '<' }
});

areaMembros.controller('areaMembros.comunidadeController', ['$scope', 'coreLanguage', '$state', 'coreFb', 'coreToast', '$filter', function($scope, $text, $state, $fb, $toast, $filter) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.setViewForm=(value)=>{
        $ctrl.viewForm = value;
    };

    $ctrl.setViewFormBanner=(value)=>{
        $ctrl.viewFormBanner = value;
    };

    $ctrl.uploadBanner=(event, mobile=false)=>{

        const file = event.target.files[0]
        const ext = file.name.split('.').pop();

        if (!['png', 'jpg', 'jpeg', 'webp', 'svg'].includes(ext.toLowerCase())) {
            return
        }

        $ctrl.loadingFile=true;

        $fb.storage.upload(`/areaMembros/${$ctrl.areaMembros.id}/comunidade`, event.target.files[0]).then(url => {
            if(!$ctrl.areaMembros.data.comunidade){ $ctrl.areaMembros.data.comunidade = {}; }

            if(!mobile){
                $ctrl.areaMembros.data.comunidade.capaUrl = url;
            }else{
                $ctrl.areaMembros.data.comunidade.capaMobUrl = url;
            }

            $ctrl.loadingFile=false;
        });
    };

    $ctrl.updateBanner=()=>{
        $state.params.showGlobalLoading = true;
        
        $fb.db.update($ctrl.areaMembros.path, {
            'comunidade.capaUrl': $ctrl.areaMembros.data.comunidade.capaUrl,
            'comunidade.capaMobUrl': $ctrl.areaMembros.data.comunidade.capaMobUrl
        }).then(()=>{
            $ctrl.setViewFormBanner(false);
            $state.params.showGlobalLoading = false;
        });
    };
    
    $ctrl.updateArea=()=>{
        $state.params.showGlobalLoading = true;
        
        $fb.db.update($ctrl.areaMembros.path, {
            'comunidade.nome': $ctrl.areaMembros.data.comunidade.nome, 
            'comunidade.subtitulo': $ctrl.areaMembros.data.comunidade.subtitulo,
            'comunidade.botao': $ctrl.areaMembros.data.comunidade.botao,
            'comunidade.link': $ctrl.areaMembros.data.comunidade.link
        }).then(()=>{
            $ctrl.setViewForm(false);
            $state.params.showGlobalLoading = false;
        });
    };

}]);